import { baseUrl } from "../Constants";
import { makeDate } from "../utils";
export const parishTableHeaders = [
  { id: "id", numeric: false, disablePadding: true, label: "ID" },
  { id: "subcountyId", numeric: false, disablePadding: true, label: "Subcounty" },
  { id: "name", numeric: false, disablePadding: true, label: "Parish Name" },
  {
    id: "createdAt",
    numeric: false,
    disablePadding: true,
    label: "Date Created",
  },
  {
    id: "updatedAt",
    numeric: false,
    disablePadding: true,
    label: "Date Updated",
  },
];

export const parishTableSchema = {
  id: { value: "", type: "number", label: "ID", readOnly: true },
  subcountyId: { value: "", type: "text", label: "Subcounty" },
  name: { value: "", type: "text", label: "Parish Name" },
  createdAt: {
    value: "",
    type: "text",
    label: "Date Created",
    readOnly: true,
  },
  updatedAt: {
    value: "",
    type: "text",
    label: "Date Updated",
    readOnly: true,
  },
};
export const createParishRecord = (data) => {
  let record = {
    id: { value: data.id, type: "number", label: "ID", readOnly: true },
    subcountyId: { value: data.subcounty.name, type: "text", label: "Subcounty" },
    name: { value: data.name, type: "text", label: "Parish" },
    createdAt: {
      value: makeDate(data.createdAt),
      type: "text",
      label: "Date Created",
      readOnly: true,
    },
    updatedAt: {
      value: makeDate(data.updatedAt),
      type: "text",
      label: "Date Updated",
      readOnly: true,
    },
  };
  return record;
};

export const parishTableIdField = "id";
export const parishTableTitle = "Parishes";
export const parishBaseUrl = baseUrl + "parishes";
